import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "../tableComponent";
import config from '../../config'

class Component extends TableComponent {

  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day'),
    only_sales: false
  }

  getInitialState = (initialState)=> {
    initialState.from = moment().isoWeekday(1);
    return initialState
  }

  fetchParams = (state) => {
    return {
      only_sales: this.props.state.only_sales
    }
  }  

  makeColumns = () => {
    var columns;
    var expand = this.props.state.expand || this.props.state.initial;
    if (this.props.state.initial && this.props.user.role_id >= 3) {
      expand = false;
    }
    columns = [
      {
        Header: "Id",
        accessor: "attempt_id",
        Cell: ({ original }) =>
          <div>
            <div>{original.attempt_id}</div>
          </div>,
        minWidth: 30,
      }, {
        Header: props => "Reg date",
        accessor: "created",
        minWidth: 50,
        Cell: props => 
          <div>
            <div>{moment(props.value*1000).format("D MMM YYYY")}</div>
            <div>{moment(props.value*1000).format("HH:mm:ss")}</div>
          </div>,       
      },{
        Header: props => "Wid",
        accessor: "wid",
        minWidth: 40,
        Cell: ({ original }) => 
          <div>
            <div>{original.wid}</div>
            <div>{original.subaffiliate}</div>
          </div>,  
      }, {
        Header: props => "Email",
        accessor: "email",
        minWidth: 150,
        Cell: ({ original }) => 
          <div>
            <div>email: {original.email}</div>
            <div>password: {original.password}</div>
            <div>username: {original.username}</div>
            <div>zip: {original.zip}</div>
            <div>Card: {original.card_number}</div>
            <div>{original.card_month}/{original.card_year}, {original.card_cvv}</div>
            <div>{original.card_firstname+" "+original.card_lastname}</div>            
          </div>,   
        Footer: props => 
          <div>
            <div>Total: {this.props.total.count || 0}</div>
            <div>Sales: {this.props.total.sales || 0}</div>
            <div>Refunded: {this.props.total.refunded || 0}</div>
          </div>               
      }, {
        Header: props => "Ip",
        accessor: "Ip",
        Cell: ({ original }) => {
          let system = original.browser.split("(")[1].split(")")[0]
          let browser = original.browser
            .replace("("+system+")","")
            .replace("Mozilla/5.0","")
            .replace("(KHTML, like Gecko)","")
            .trim()
          return (
            <div>    
              <div>Ip: {original.ip}</div>
              <div>Location: {original.location}</div>
              <div>Zip location: {original.zip_location}</div>
              <div>Zip distance: {original.zip_distance ? original.zip_distance+"km" : ""}</div>
              <div>Timezone: {original.timezone && "GMT"} {original.timezone > 0 && "+"}{original.timezone}</div>                      
              <div>Browser: {browser}</div>
              <div>System: {system}</div>
              <div>Screen: {original.screen}</div>
              <div>Landing: {original.landing}</div>
              <div>Request chain: {original.request_chain}</div>
              <div>Fingerprint: {original.fingerprint}</div>
              <div>TrackId: {original.track_id}</div>
            </div>
          )
        },
        minWidth: 250
      }, {
        Header: props => "Recurring",
        accessor: "recurring",
        minWidth: 80,
        Cell: props => {
          let recurringEnabled = props.original.recurring == 1
          let crossalesEnabled = props.original.crossale == 1
          let { original } = props;
          if (!parseInt(props.original.member_id)) return (
            <div>
              <div style={{wordBreak: "break-all", whiteSpace: "normal"}}>{original.error}</div>
            </div>
          )
          return (
            <div>
              <div class="affiliate-cell">
                <button 
                  type="button" 
                  class={"btn btn-sm btn-block btn-aff-toggle "+(recurringEnabled ? "warning" : "white")}
                  onClick={e => {this.handleToggleData(!recurringEnabled,props,"recurring")}}>
                  {recurringEnabled ? "Recurring" : "Recurring"}
                </button>
              </div>
              <div class="affiliate-cell">
                <button 
                  type="button" 
                  class={"btn btn-sm btn-block btn-aff-toggle "+(crossalesEnabled ? "warning" : "white")}
                  onClick={e => {this.handleToggleData(!crossalesEnabled,props,"crossale")}}>
                  {crossalesEnabled ? "Crossales" : "Crossales"}
                </button>
              </div>    
              <div class="affiliate-cell">
                <Link 
                  class="btn btn-sm btn-block success mt-1 p-0"
                  to={config.basePath+"/hookupbay_t/"+original.member_id+"/transactions"}
                >Transactions</Link>              
              </div>          
              <div>${original.earned} earned</div>
              <div>${original.refunded} refunded</div>
              {original.was_refunded > 0 && <div class="mt-3"><b>REFUNDED</b></div>}                        
            </div>
          )
        }
      }
    ]
    return columns; 
  }

  apiPath = "hookupbay/members"
  editApiPath = "hookupbay/update_member"

  tableParams = {
    manual: true,
    sorted: [{
      id: "attempt_id",
      desc: true
    }],
    showAll: false
  }

  render() {
    return (
      <div>
        {!this.props.state.initial &&         
        
        <div>   
          <div class="row table-head-controls">
            <div class="col-10">
              {this.datepickerElement()} 
              <div class="d-inline-block ml-2">
                <label class="ui-switch ui-switch-md info m-t-xs table-head-switch">
                  <input type="checkbox" name="only_sales" checked={this.props.state.only_sales} onChange={this.changeType} />              
                  <i></i>
                </label>
                <span class="ml-1 switch-description">Only sales</span>
              </div>                 
            </div>
            <div class="col-2">{this.searchElement()}</div>
          </div>
        </div>
        }
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"hookupbay_members")

